import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Pagination } from "@/components/molecules/Pagination";
import { PaginationType } from "@/models/common";
import { TableContainer } from "@mui/material";
import { CarUnderuseAnswersConstants, getUnderuseReasonLabel, getRestartPlanLabel } from "./CarUnderuseAnswersConstants";
import { CarUnderuseAnswer } from "@/models/carUnderuseEvents/answers";
import { formatYearMonth } from "./CarUnderuseEventsConstants";

export type CarUnderuseAnswersListProps = {
  onChangePage: (page: number) => void;
  pagingData: PaginationType;
  answers: CarUnderuseAnswer[];
};

export const CarUnderuseAnswersList = (props: CarUnderuseAnswersListProps) => {
  const {
    onChangePage,
    answers,
    pagingData,
  } = props;

  return (
    <React.Fragment>
      <TableContainer className="table-container-width">
        <Table size="small" className="list-head">
          <TableHead>
            <TableRow>
              <TableCell>
                {CarUnderuseAnswersConstants.YearMonth}
              </TableCell>
              <TableCell>
                {CarUnderuseAnswersConstants.CompanyOffice}
              </TableCell>
              <TableCell>
                {CarUnderuseAnswersConstants.RadioNumber}
              </TableCell>
              <TableCell>
                {CarUnderuseAnswersConstants.UnderuseReason}
              </TableCell>
              <TableCell>
                {CarUnderuseAnswersConstants.RestartPlanDate}
              </TableCell>
              <TableCell>
                {CarUnderuseAnswersConstants.RestartPlanDetail}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {answers.map((row, index) => (
              <TableRow key={`${row.evCarId}-${row.yearMonth}-${index}`} hover sx={{ wordBreak: "break-all" }}>
                <TableCell>
                  {formatYearMonth(row.yearMonth)}
                </TableCell>
                <TableCell>
                  {row.officeName}
                </TableCell>
                <TableCell>
                  {row.vehicleCode}
                </TableCell>
                <TableCell>
                  {getUnderuseReasonLabel(row.underuseReason)}
                </TableCell>
                <TableCell>
                  {getRestartPlanLabel(row)}
                </TableCell>
                <TableCell sx={{ maxWidth: 350 }}>
                  <div style={{ maxHeight: 150, wordBreak: 'break-word', whiteSpace: 'pre-wrap', overflowY: 'auto' }}>
                    {row.restartPlanDetail}
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination
        total={pagingData.total}
        page={pagingData.page}
        size={pagingData.size}
        setPage={onChangePage}
      />
    </React.Fragment>
  );
};
